<template>
	<div
		class="bg-success d-flex flex-column w-100"
		:class="{ loading }"
		id="game-table"
	>
		<li class="navbar navbar-expand navbar-dark">
			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbar"
				aria-controls="navbar"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>
			<div
				class="collapse navbar-collapse"
				id="navbar"
			>
				<div class="form-inline my-2 my-lg-0">
					<button
						:disabled="loading"
						class="btn btn-danger my-2 my-sm-0 mr-2"
						v-if="showBoard && player > 0"
						@click="abort"
					><i class="fas fa-fw fa-door-open"></i> <span class="d-none d-lg-inline ml-1">Abort</span></button>
					<button
						:disabled="loading"
						class="btn btn-success my-2 my-sm-0 mr-2"
						v-if="showBoard && player == 0"
						@click="showWindow('welcome')"
					><i class="fas fa-fw fa-play-circle"></i> <span class="d-none d-lg-inline ml-1">New game</span></button>
					<button
						:disabled="loading"
						class="btn btn-light my-2 my-sm-0 mr-2"
						v-if="showBoard"
						@click="showRules"
					><i class="fas fa-fw fa-question"></i> <span class="d-none d-lg-inline ml-1">Rules</span></button>
					<button
						:disabled="loading || (turn < 2 && !kiddingMode)"
						class="btn btn-light my-2 my-sm-0 mr-2"
						v-if="showBoard && player > 0"
						@click="revokeMove"
					><i class="fas fa-fw fa-undo"></i> <span class="d-none d-lg-inline ml-1">Undo</span></button>
					<button
						:disabled="loading || kiddingMode"
						class="btn btn-light my-2 my-sm-0 mr-2"
						v-if="showBoard && player > 0"
						@click="bestMove"
					><i class="fas fa-fw fa-life-ring"></i> <span class="d-none d-lg-inline ml-1">Best move</span></button>
					<button
						:disabled="loading"
						class="btn btn-light my-2 my-sm-0 mr-2"
						v-if="showBoard"
						@click="bordered = !bordered"
					><i class="fas fa-fw fa-border-all"></i> <span class="d-none d-lg-inline ml-1">{{ bordered ? 'Hide' : 'Show'}} grid</span></button>
				</div>
				<h4 class="mb-0 ml-auto text-right text-primary">
					Heart Hunter<br>
					<span class="d-none d-md-inline">The game you always wanted to win!</span>
				</h4>
			</div>
		</li>
		<div class="d-flex flex-column flex-lg-row flex-grow-1">
			<PlayerPanel
				forPlayer="1"
				:conflicts="conflicts"
				:currentPlayer="player"
				:kiddingMode="kiddingMode"
				:showTemplate="showTemplate"
				v-if="showBoard"
				@dragend="templateDragEnd"
			/>
			<div class="col flex-grow-1 align-items-center d-flex flex-column justify-content-center">
				<Board
					:bordered="bordered"
					:cols="settings.width"
					:rows="settings.height"
					:stones="stones"
					v-if="showBoard"
				/>
				<div
					class="m-auto position-absolute spinner-grow text-light"
					style="width: 25vmin; height: 25vmin;"
					role="status"
					v-if="loading"
				></div>
			</div>
			<PlayerPanel
				forPlayer="2"
				:conflicts="conflicts"
				:currentPlayer="player"
				:kiddingMode="kiddingMode"
				:showTemplate="showTemplate"
				v-if="showBoard"
				@dragend="templateDragEnd"
			/>
		</div>
		<div
			class="d-flex h-100 position-absolute w-100"
			id="loading"
			v-if="loading"
		></div>
		<PrivacyPolicyWin
			id="privacy-win"
			@ga-allowed="gaAllowed"
			@ga-denied="gaDenied"
		/>
		<WelcomeWin
			id="welcome-win"
			:settings="settings"
			@privacy="showPrivacy"
			@rules="showRules"
			@settings="showSettings"
			@start="start"
		/>
		<RulesWin
			id="rules-win"
			:version="settings ? settings.version : null"
			@closed="closeRules"
		/>
		<SettingsWin
			id="settings-win"
			@loaded="settingsLoaded"
		/>
		<AbortWin
			id="abort-win"
			@restart="restart"
			@settings="breakAndSettings"
		/>
		<GameOverWin
			id="game-over-win"
			:kiddingMode="kiddingMode"
			:winner="lastWinner"
			@restart="start"
			@settings="showWindow('settings')"
		/>
		<ErrorWin
			id="error-win"
			:error="lastError"
		/>
	</div>
</template>

<script>
import Cookies from "js-cookie";
import HHEvents from "../logic/events";
import HH from "../logic/logic";
import GA from "../ga";

const PP_COOKIE_NAME = "hh-pp-v1";

export default {
	name: "gameTable",
	data() {
		return {
			bordered: true,
			conflicts: 0,
			lastError: null,
			lastWinner: null,
			loading: false,
			player: 0,
			settings: null, // comes from SettingsWin
			showBoard: false,
			showTemplate: false,
			stones: [
				// GPVS [x,y,d,p]
			],
			turn: 0
		};
	},
	computed: {
		kiddingMode() {
			return this.settings ? this.settings.version === "pc2v0_0" : false;
		}
	},
	methods: {
		abort() {
			this.showWindow("abort");
			GA.sendButtonEvent("abort", "Abort game");
		},
		bestMove() {
			HH.bestMove();
			GA.sendButtonEvent("best-move", "Best move");
		},
		async breakAndSettings() {
			this.player = 0;
			$(".modal").modal("hide");
			const s = await HH.break();
			if (s) {
				this.showWindow("settings");
			}
			GA.sendButtonEvent("settings", "Abort / Settings");
		},
		closeRules() {
			$(".modal").modal("hide");
			if (this.player == 0) {
				this.showWindow("welcome");
			}
		},
		displayBoard() {
			this.conflicts = 0;
			this.player = 0;
			this.showBoard = false;
			this.stones.splice(0, this.stones.length);
			this.turn = 0;
			this.$nextTick(() => {
				this.showBoard = true;
				$(".modal").modal("hide");
			});
		},
		error(e) {
			this.lastError = e;
			this.showWindow("error");
			GA.sendErrorEvent("error", e);
		},
		gaAllowed() {
			Cookies.set(PP_COOKIE_NAME, 1, { expires: 365 });
			this.showWindow("welcome");
			GA.addGA();
		},
		gaDenied() {
			Cookies.set(PP_COOKIE_NAME, -1, { expires: 365 });
			window.location.reload();
		},
		gameOver(winner) {
			this.lastWinner = parseInt(winner, 10);
			this.player = 0;
			this.showWindow("game-over");
		},
		initiatePlayerTurn(player) {
			this.showTemplate = false;
			this.player = parseInt(player, 10);
			this.$nextTick(() => {
				this.showTemplate = true;
			});
		},
		restart() {
			$(".modal").modal("hide");
			HH.restartGame();
			GA.sendButtonEvent("start-game", "Restart");
		},
		revokeMove() {
			HH.revokeMove();
			GA.sendButtonEvent("revoke-move", "Revoke move");
		},
		setSettings(settings) {
			this.settings = settings;
		},
		settingsLoaded(settings) {
			this.setSettings(settings);
			const pp = Cookies.get(PP_COOKIE_NAME);
			if (pp === undefined) {
				this.showWindow("privacy");
			} else if (pp == 1) {
				this.gaAllowed();
			} else {
				this.showWindow("welcome");
			}
		},
		showPrivacy() {
			this.showWindow("privacy");
			GA.sendButtonEvent("privacy", "Privacy policy");
		},
		showRules() {
			this.showWindow("rules");
			GA.sendButtonEvent("rules", "Rules");
		},
		showSettings() {
			this.showWindow("settings");
			GA.sendButtonEvent("settings", "Settings");
		},
		showWindow(w) {
			$(".modal").modal("hide");
			$(`#${w}-win`).modal("show");
		},
		start() {
			$(".modal").modal("hide");
			HH.newGame();
			GA.sendButtonEvent("start-game", "Start game");
		},
		templateDragEnd(data) {
			const { newPosition, d, player } = data;
			const tlc = document.getElementsByClassName("board-cell")[0];
			const tlcr = tlc.getBoundingClientRect();
			let x = Math.round((newPosition.left - tlcr.left) / tlcr.width);
			let y = Math.round((newPosition.top - tlcr.top) / tlcr.height);
			y = this.settings.height - y - 2;
			const xIn = 0 <= x && x <= this.settings.width - 2;
			const yIn = 0 <= y && y <= this.settings.height - 2;
			if (xIn && yIn) {
				HH.humanStep([x, y, d, player]);
			} else {
				this.showTemplate = false;
				this.initiatePlayerTurn(player);
			}
		},
		updateBoard(data) {
			this.showTemplate = false;
			const { move, remove, conflicts, partyTurn } = data;
			this.conflicts = conflicts || 0;
			this.turn = partyTurn || 0;
			(move || []).forEach(gpv => {
				this.stones.push(gpv);
			});
			(remove || []).forEach(gpv => {
				const search = JSON.stringify(gpv);
				const index = this.stones.map(e => JSON.stringify(e)).indexOf(search);
				if (index > -1) {
					this.stones.splice(index, 1);
				}
			});
		}
	},
	created() {
		const self = this;
		HHEvents.listen(HHEvents.DISPLAY_BOARD, this.displayBoard);
		HHEvents.listen(HHEvents.GAME_OVER, this.gameOver);
		HHEvents.listen(HHEvents.ERROR, this.error);
		HHEvents.listen(HHEvents.INITIATE_PLAYER_TURN, this.initiatePlayerTurn);
		HHEvents.listen(HHEvents.LOADING_START, () => {
			self.loading = true;
		});
		HHEvents.listen(HHEvents.LOADING_END, () => {
			self.loading = false;
		});
		HHEvents.listen(HHEvents.TOGGLE_GRID, enabled => {
			self.bordered = enabled;
		});
		HHEvents.listen(HHEvents.UPDATE_BOARD, this.updateBoard);

		HHEvents.listen("injectSettings", this.setSettings);
	},
	beforeDestroy() {
		HHEvents.vue.$off(HHEvents.DISPLAY_BOARD);
		HHEvents.vue.$off(HHEvents.GAME_OVER);
		HHEvents.vue.$off(HHEvents.ERROR);
		HHEvents.vue.$off(HHEvents.INITIATE_PLAYER_TURN);
		HHEvents.vue.$off(HHEvents.LOADING_START);
		HHEvents.vue.$off(HHEvents.LOADING_END);
		HHEvents.vue.$off(HHEvents.UPDATE_BOARD);

		HHEvents.vue.$off("injectSettings");
	}
};
</script>

<style>
#game-table {
	background-image: url("../assets/pool_table.png");
	filter: none;
	transition: 0.25s ease filter; /* duration of loading effect to disappear */ /* not working though :( */
}

#game-table.loading {
	filter: saturate(0.5) brightness(0.5);
	transition: 5s ease filter; /* duration of loading effect to appear */
}

#loading {
	left: 0;
	top: 0;
	z-index: 100;
}
</style>